import React from "react";
import {
  Box,
  Button,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import DesktopWindowsRoundedIcon from "@mui/icons-material/DesktopWindowsRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import CloudDoneRoundedIcon from "@mui/icons-material/CloudDoneRounded";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function LandingStudioToolbar({
  title,
  publicStatus,
  revision,
  device,
  saving,
  canOpenPublic,
  onBack,
  onChangeDevice,
  onOpenSettings,
  onOpenPublic,
}) {
  const statusLabel =
    publicStatus === "published"
      ? "Publicada"
      : publicStatus === "maintenance"
        ? "Mantenimiento"
        : "Borrador";

  return (
    <Box
      component="header"
      sx={{
        position: "fixed",
        inset: "0 0 auto 0",
        zIndex: 1100,
        minHeight: 64,
        px: { xs: 1, sm: 1.5 },
        py: 1,
        bgcolor: "rgba(255,255,255,.96)",
        borderBottom: "1px solid rgba(25,36,47,.10)",
        backdropFilter: "blur(18px)",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
          <Tooltip title="Volver al panel">
            <IconButton onClick={onBack} size="small" sx={{ border: "1px solid rgba(25,36,47,.12)" }}>
              <ArrowBackRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ fontWeight: 950, color: BRAND.dark, lineHeight: 1.08 }} noWrap>
              {title || "Editor visual"}
            </Typography>
            <Typography variant="caption" sx={{ color: "rgba(25,36,47,.55)", display: { xs: "none", sm: "block" } }}>
              Tocá cualquier parte de la página para editarla
            </Typography>
          </Box>
          <Chip
            size="small"
            label={statusLabel}
            color={publicStatus === "published" ? "success" : "default"}
            sx={{ display: { xs: "none", md: "inline-flex" }, fontWeight: 850 }}
          />
        </Stack>

        <Stack direction="row" alignItems="center" spacing={0.7}>
          <Stack
            direction="row"
            sx={{
              p: 0.35,
              borderRadius: 999,
              bgcolor: "rgba(25,36,47,.06)",
              display: { xs: "none", sm: "flex" },
            }}
          >
            <Tooltip title="Vista de computadora">
              <IconButton
                size="small"
                onClick={() => onChangeDevice("desktop")}
                sx={{
                  bgcolor: device === "desktop" ? "#fff" : "transparent",
                  color: device === "desktop" ? BRAND.orange : "rgba(25,36,47,.56)",
                  boxShadow: device === "desktop" ? "0 2px 8px rgba(25,36,47,.10)" : "none",
                }}
              >
                <DesktopWindowsRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Vista de celular">
              <IconButton
                size="small"
                onClick={() => onChangeDevice("mobile")}
                sx={{
                  bgcolor: device === "mobile" ? "#fff" : "transparent",
                  color: device === "mobile" ? BRAND.orange : "rgba(25,36,47,.56)",
                  boxShadow: device === "mobile" ? "0 2px 8px rgba(25,36,47,.10)" : "none",
                }}
              >
                <PhoneIphoneRoundedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>

          <Chip
            size="small"
            icon={saving ? <SyncRoundedIcon /> : <CloudDoneRoundedIcon />}
            label={saving ? "Guardando" : `v${revision || 1}`}
            sx={{ display: { xs: "none", lg: "inline-flex" }, fontWeight: 850 }}
          />

          <Tooltip title="Ajustes generales">
            <IconButton onClick={onOpenSettings} size="small" sx={{ border: "1px solid rgba(25,36,47,.12)" }}>
              <SettingsRoundedIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Button
            variant="outlined"
            size="small"
            endIcon={<OpenInNewRoundedIcon />}
            disabled={!canOpenPublic}
            onClick={onOpenPublic}
            sx={{
              display: { xs: "none", md: "inline-flex" },
              borderRadius: 999,
              px: 1.5,
              textTransform: "none",
              fontWeight: 900,
              color: BRAND.dark,
              borderColor: "rgba(25,36,47,.18)",
            }}
          >
            Ver publicada
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
